import { useUser } from "../contexts/userContext/userContext.js";
import { useMail } from "../contexts/mailContext/mailContext.js";

const useMailSender = () => {
  const { getUserData } = useUser();
  const { getSender } = useMail();
  const getMailSenderBrandedHeader = getSender()
    ? getSender().brandedHeader
    : null;
  const isMailSenderSubscribed = getSender()
    ? getSender().isSubscribed || getSender().email === getUserData().UserName
    : null;
  const isMailSenderHasBusinessSubscription = getSender()
    ? getSender().hasBusinessPackage
    : null;
  const getMailSenderProfileImage = () =>
    getSender() && getSender().profileImage;
  const isMailSender = () =>
    getSender() && getUserData()
      ? getSender().email === getUserData().UserName
      : false;
  const isMailSenderAndBusinessSubscriber = () =>
    getSender() && getUserData()
      ? getSender().email === getUserData().UserName &&
        getSender().hasBusinessPackage
      : false;
  return {
    isMailSenderHasBusinessSubscription,
    getMailSenderBrandedHeader,
    isMailSenderSubscribed,
    getMailSenderProfileImage,
    isMailSender,
    isMailSenderAndBusinessSubscriber,
  };
};

export default useMailSender;
